import { motion } from "framer-motion";
import { useScrollProgress } from "../../hooks/useScrollAnimations";

const ScrollProgress = () => {
  const progress = useScrollProgress();

  return (
    <motion.div
      className="fixed top-0 left-0 right-0 z-50 h-1 bg-lightNavy/20"
      initial={{ scaleX: 0 }}
      animate={{ scaleX: 1 }}
      transition={{ duration: 0.3 }}
    >
      <motion.div
        className="h-full bg-gradient-to-r from-accent to-secondary origin-left"
        style={{ scaleX: progress / 100 }}
        transition={{ type: "spring", stiffness: 100, damping: 30 }}
      />
    </motion.div>
  );
};

export default ScrollProgress;